import { LinkV2, styled } from '@withjoy/joykit';
import { dottedUnderlineStyles } from '@shared/components/DottedButton/DottedButton.styles';

/**
 * A link in a consent line — the registration contact step's and the post-RSVP texts consent. Exported
 * so the matched-page provider can keep its hover and focus colour in the page's text colour, where
 * the neutral hover colour may not read. Render it through `ConsentLink`.
 */
export const StyledConsentLink = styled(LinkV2)`
  ${dottedUnderlineStyles}
`;
